<template>
  <!-- 话务管理-AI坐席管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
        <el-button
          v-if="permissionList.bulkDelBtn"
          size="small"
          type="primary"
          icon="el-icon-delete"
          @click="doBulkDel()"
        >
          删除
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.editBtn && row.workStatus == 0"
          type="text"
          size="small"
          @click="openDialog('edit', row)"
        >
          更换绑定
        </el-button>
        <el-button
          v-if="permissionList.bindTaskBtn"
          type="text"
          size="small"
          @click="openDialog('bindTask', row)"
        >
          关联任务
        </el-button>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="60%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Form
        v-if="isDialogShow && dialogType != 'bindTask'"
        :dialogType="dialogType"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
      <TaskList
        v-if="isDialogShow && dialogType == 'bindTask'"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @close="closeDialog"
      ></TaskList>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from './form';
import TaskList from './task-list';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, delApi } from '@/api/call-system/call-manage/AI-operator-manage';
import { operatorStatusMap } from '../../common';

export default {
  components: {
    Form,
    TaskList,
  },
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      searchForm: {}, // 搜索条件
      selectionList: [], // 勾选项集合
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 160,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '话务号',
            prop: 'serviceNo',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '坐席姓名',
            prop: 'serviceName',
          },
          {
            label: '坐席工号',
            prop: 'serviceCode',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '状态',
            prop: 'workStatus',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_ai_work_status',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'string',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.callSystem_callManage_AIOperatorManage_add, false),
        bulkDelBtn: this.vaildData(
          this.permission.callSystem_callManage_AIOperatorManage_bulkDel,
          false
        ),
        editBtn: this.vaildData(this.permission.callSystem_callManage_AIOperatorManage_edit, false),
        bindTaskBtn: this.vaildData(
          this.permission.callSystem_callManage_AIOperatorManage_bindTask,
          false
        ),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 382; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.selectionClear();
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 勾选项发生变化 */
    selectionChange(arr) {
      this.selectionList = arr;
    },
    /* 清空勾选项 */
    selectionClear() {
      this.selectionList = [];
      if (this.$refs.crud) {
        this.$refs.crud.toggleSelection();
      }
    },
    /* 批量删除 */
    doBulkDel() {
      if (this.selectionList.length == 0) {
        this.$message.warning('请选择至少一条数据!');
        return;
      }
      let canDel = true;
      for (let i = 0, len = this.selectionList.length; i < len; i++) {
        if (this.selectionList[i].workStatus != this.operatorStatusMap.offline) {
          canDel = false;
          break;
        }
      }
      if (!canDel) {
        this.$message.warning('只能删除空闲状态的坐席!');
        return;
      }
      this.$confirm('确定将选择数据删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let ids = this.selectionList.map((item) => {
            return item.id;
          });
          return delApi({
            ids: ids.join(','),
          });
        })
        .then(() => {
          this.updateTableDataSuccess();
          this.$message.success('操作成功!');
        });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增坐席',
        edit: '更换绑定',
        bindTask: '关联任务',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = true;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
